import React, { useEffect, useState } from "react";
import MathJax from "react-mathjax2";
import TYPE from "../../../constant/TYPE";
import useLaTexCode from "../../../hooks/useLaTexCode";

const Viewer = ( props ) => {

  const [ question, setQuestion ] = useState( [] );
  const [ answer, setAnswer ] = useState( [] );
  const [ answerIndex, setAnswerIndex ] = useState( 0 );

  const { getEndScope } = useLaTexCode();

  useEffect( () => {
    let answer = [];
    const mapExercise = ( value, index, origin ) => {
      const cssId = `${ TYPE.ID.ANSWER_AREA }${ index }}{`;
      if ( index ) {
        const startValue = value.slice( value.indexOf( '{' ) );
        const endPoint = getEndScope( startValue );
        answer = [ ...answer, `\\phantom{${ startValue.slice( 1, endPoint - 1 ) }}` ];
        return `${ startValue.slice( endPoint - 1 ) }${ origin.length === index + 1 ? '' : cssId }`;
      } else {
        return `${ value }${ cssId }`;
      }
    };
    setQuestion( props.question.split( 'inputArea' ).map( mapExercise ) );
    setAnswer( answer );
  }, [ props.question ] );

  useEffect( () => {
    if ( props.arrow ) {
      switch ( props.arrow.split( '?' )[ 0 ] ) {
        case '<' :
          setAnswerIndex( 0 < answerIndex ? answerIndex - 1 : answer.length - 1 );
          break;
        case '>' :
          setAnswerIndex( answer.length - 1 > answerIndex ? answerIndex + 1 : 0 );
          break;
      }
    }
  }, [ props.arrow ] );

  useEffect( () => {
    props.answer && setAnswer( answer.map( ( v, i ) => i === answerIndex ? props.answer : v ) );
  }, [ props.answer ] );

  return (
    <div style={ { float : 'left', width : '40%' } }>
      <MathJax.Node>{ question.map( ( v, i, o ) => i + 1 === o.length ? v : `${ v }${ answer[ i ] }` ).join( '' ) }</MathJax.Node>
    </div>
  );

};

export default Viewer;
